import { Link, useNavigate } from 'react-router-dom';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaRss } from 'react-icons/fa';
import { FaXTwitter, FaLinkedinIn } from 'react-icons/fa6';

const pageLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/technologies', label: 'Technologies' },
  { to: '/process', label: 'Process' },
  { to: '/contact', label: 'Contact' },
];

const serviceLinks = [
  { to: '/agentic-ai', label: 'Agentic AI' },
  { to: '/arvr', label: 'AR/VR' },
  { to: '/meta', label: 'Meta Applications' },
  { to: '/services', label: 'Services' },
];

const socialLinks = [
  { href: 'https://twitter.com/mnminnovators', label: 'MMI on X', Icon: FaXTwitter },
  { href: 'https://www.linkedin.com/company/m-&-m-innovators/', label: 'MMI on LinkedIn', Icon: FaLinkedinIn },
  { href: 'http://mnminnovators.blogspot.com/', label: 'MMI Blog', Icon: FaRss },
];

const legalLinks = [
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms of Service' },
  { to: '/cookies', label: 'Cookie Policy' },
];

function Footer() {
  const navigate = useNavigate();

  const goToLegal = (to) => (event) => {
    event.preventDefault();
    navigate(to);
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  };

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-col footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/rounded.png" alt="MMI" />
            </Link>
            <p className="footer-tagline">
              Building Agentic AI, immersive AR/VR, and intelligent Meta applications.
            </p>
            <div className="footer-social">
              {socialLinks.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  className="footer-social-link"
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Pages</h3>
            <ul className="footer-links-list">
              {pageLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Services</h3>
            <ul className="footer-links-list">
              {serviceLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-heading">Contact</h3>
            <ul className="footer-contact-list">
              <li>
                <FaEnvelope className="footer-contact-icon" aria-hidden="true" />
                <a href="mailto:hello@mmi.com">hello@mmi.com</a>
              </li>
              <li>
                <FaPhoneAlt className="footer-contact-icon" aria-hidden="true" />
                <a href="tel:+923205352001">03205352001</a>
              </li>
              <li>
                <FaMapMarkerAlt className="footer-contact-icon" aria-hidden="true" />
                <span>Bahria Town, Islamabad</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-divider" aria-hidden="true" />

        <div className="footer-bottom">
          <nav className="footer-legal" aria-label="Legal">
            {legalLinks.map(({ to, label }, index) => (
              <span key={to} className="footer-legal-item">
                {index > 0 && <span className="footer-legal-sep" aria-hidden="true">|</span>}
                <Link to={to} onClick={goToLegal(to)}>{label}</Link>
              </span>
            ))}
          </nav>
          <p className="footer-copy">© 2026 MMI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
